// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"tZ-z","subtitle":"uZ-z","wrapper":"vZ-z","leftArrow":"wZ-z","rightArrow":"xZ-z"};